import { OfferCategoryApiClient } from '@fourthwall/services/dist/OfferCategoryApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useOfferCategoryQuery = createQueryHook(OfferCategoryApiClient.getOfferCategory, {
  queryKey: ['offerCategory'],
})
